import { Component } from 'react';
var LocalizationManager = require('../Managers/LocalizationManager.js');

export default class Loc extends Component 
{
    constructor(props) 
    {
        super(props);
        var state = {
            locKey : this.props.locKey,
            locParams : typeof this.props.locParams == null ? [] : this.props.locParams,
            localizedString : this.props.locKey,
            translated : false
        };
        this.state = state;
    }

    componentDidMount()
    {
        var self = this;
        LocalizationManager.localizedStringForKey(this.props.locKey, this.props.locParams, (retrievedString)=>
        {
            self.setState({localizedString:retrievedString, translated:true});
        });
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.locKey!=this.props.locKey) {
            this.componentDidMount();
        }
    }

    render()
    {
        if( this.state.localizedString == this.props.locKey && !this.state.translated ) return "";

        return (
            this.state.localizedString            
        );
    }
};